import {
  ActivityIndicator,
  Text,
  TextInput,
  View
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Card from '../../shared/card/Card'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'
import { useFormsStore } from '../../../stores/onboarding'
import * as yup from 'yup'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'

const WvInformationForm = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params
    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postwvonline } = useFormsStore()
    const intialValues = {
        noOfExemptions: '',
        specialWithholdingStatus: '',
        additionalwithholding: '',
        singleExemptions: '',
        marriedExemptions: '',
        dependentsExemption: '',
        stateofresidence: ""
    }
    const w4schema = () => {
        const baseSchema = {
            // noOfExemptions: yup
            //     .string()
            //     .required('No of exemptions is a required field'),
            specialWithholdingStatus: yup
                .string()
                .required('Less tax withheld is a required field'),
            additionalwithholding: yup.string().nullable(),
            singleExemptions: yup
                .string()
                .nullable()
                .test(
                    'single-required',
                    'Single or Married exemptions is a required field',
                    function (value) {
                        const { marriedExemptions } = this.parent
                        if (marriedExemptions) return true
                        return !!value
                    }
                )
                .test(
                    'single-format',
                    'Single exemptions must be either 0 or 1',
                    function (value) {
                        if (!value) return true
                        return ['0', '1'].includes(value)
                    }
                ),
            marriedExemptions: yup
                .string()
                .nullable()
                .test(
                    'married-required',
                    'Single or Married exemptions is a required field',
                    function (value) {
                        const { singleExemptions } = this.parent
                        if (singleExemptions) return true
                        return !!value
                    }
                )
                .test(
                    'married-format',
                    'Married exemptions must be either 0, 1 or 2',
                    function (value) {
                        if (!value) return true
                        return ['0', '1', '2'].includes(value)
                    }
                ),
            dependentsExemption: yup
                .string()
                .required('Dependents exemption is a required field'),
            stateofresidence: yup.string().nullable()
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()
    const options2 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    const options3 = [
        { key: 1, value: 'Kentucky' },
        { key: 2, value: 'Maryland' },
        { key: 3, value: 'Ohio' },
        { key: 4, value: 'Pennsylvania' },
        { key: 5, value: 'Virginia' }
    ]

    const findState = (id: number) => {
        return options3.find((item) => item.key == id)?.value
    }
    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'WV Withholding Taxation'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const getMaritalStatus = (single: any, married: any) => {
                            if (single !== undefined && single !== null && single !== '') return 1
                            if (married !== undefined && married !== null && married !== '') return 0
                            return null
                        }
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey: intializeStore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            // noOfExemptions: values?.noOfExemptions,
                            noOfExemptions:
                                Number(values?.singleExemptions) +
                                Number(values?.marriedExemptions) +
                                Number(values?.dependentsExemption),
                            specialWithholdingStatus: getMaritalStatus(values?.singleExemptions, values?.marriedExemptions),
                            additionalWithholding: values?.additionalwithholding
                                ? values?.additionalwithholding
                                : 0,
                            singleExemptions: values?.singleExemptions ? Number(values?.singleExemptions) : null,
                            marriedExemptions: values?.marriedExemptions ? Number(values?.marriedExemptions) : null,
                            dependentExemptions: values?.dependentsExemption ? Number(values?.dependentsExemption) : null,
                            LowerWithheldRate: values?.specialWithholdingStatus,
                            LegalResidentState: values?.stateofresidence ? findState(values?.stateofresidence) : ''
                        }
                        const response = await postwvonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('WvInformationOnline', {
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    completeOnline: mode === 'upload' ? false : true,
                                    total:
                                        Number(values?.singleExemptions) +
                                        Number(values?.marriedExemptions) +
                                        Number(values?.dependentsExemption),
                                    LegalResidentState: values?.stateofresidence ? findState(values?.stateofresidence) : ''
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <Card>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '70%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'If SINGLE, and you claim an exemption, enter "1", if you do not, enter "0" '
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.singleExemptions}
                                        keyboardType="numeric"
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.setFieldValue('singleExemptions', text)
                                                if (text !== '') {
                                                    props.setFieldValue('marriedExemptions', '')
                                                }
                                            }
                                        }}
                                    />
                                    {props.touched.singleExemptions &&
                                        props.errors.singleExemptions && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.singleExemptions}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '70%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'If MARRIED, one exemption each for husband and wife if not claimed on another certificate. (a) If you claim both of these exemptions, enter "2" (b) If you claim one of these exemptions, enter "1" (c) If you claim neither of these exemptions, enter "0" '
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.marriedExemptions}
                                        keyboardType="numeric"
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.setFieldValue('marriedExemptions', text)
                                                if (text !== '') {
                                                    props.setFieldValue('singleExemptions', '')
                                                }
                                            }
                                        }}
                                    />
                                    {props.touched.marriedExemptions &&
                                        props.errors.marriedExemptions && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.marriedExemptions}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '70%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'If you claim exemptions for one or more dependents, enter the number of such exemptions *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.dependentsExemption}
                                        keyboardType="numeric"
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.handleChange('dependentsExemption')(text)
                                            }
                                        }}
                                    />
                                    {props.touched.dependentsExemption &&
                                        props.errors.dependentsExemption && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.dependentsExemption}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Are you single, head of household, or married with a non-working spouse, and receiving wages from only one job—and want less tax withheld? *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <SelectKeyValue
                                        title="Are you single, head of household, or married with a non-working spouse, and receiving wages from only one job—and want less tax withheld?"
                                        options={options2}
                                        selectedOption={mapSelectValue(
                                            options2,
                                            props.values.specialWithholdingStatus
                                        )}
                                        onSelect={(option: any) => {
                                            props.setFieldValue(
                                                'specialWithholdingStatus',
                                                option - 1
                                            )
                                        }}
                                        textColor="primary"
                                    />
                                    {props.touched.specialWithholdingStatus &&
                                        props.errors.specialWithholdingStatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.specialWithholdingStatus}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {!props.values.stateofresidence && (
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '70%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter the amount of additional withholding'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.additionalwithholding}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('additionalwithholding')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.additionalwithholding &&
                                            props.errors.additionalwithholding && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalwithholding}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                            )}

                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'I certify that I am a legal resident of the state of ____________ and am not subject to West Virginia withholding because l meet the requirements set forth under the Servicemembers Civil Relief Act, as amended by the Military Spouses Residency Relief Act?'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <SelectKeyValue
                                        title="I certify that I am a legal resident of the state of ____________ and am not subject to West Virginia withholding because l meet the requirements set forth under the Servicemembers Civil Relief Act, as amended by the Military Spouses Residency Relief Act?"
                                        options={options3}
                                        selectedOption={mapSelectValue(
                                            options3,
                                            props.values.stateofresidence
                                        )}
                                        onSelect={(option: any) => {
                                            props.setFieldValue(
                                                'stateofresidence',
                                                option
                                            )
                                            if (option) {
                                                props.setFieldValue('additionalwithholding', '')
                                            }
                                        }}
                                        textColor="primary"
                                    />
                                    {props.touched.stateofresidence &&
                                        props.errors.stateofresidence && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.stateofresidence}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}
                        </Card>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default WvInformationForm